import React, {useState} from "react";
import PropTypes from "prop-types";

export default function DragNDropFile(props){
    const drop = React.useRef(null);
    const fileInput = React.useRef(null);

    const [dragging,setDragging] = useState(false);
    const [msg,setMsg] = useState(null);

    React.useEffect(() => {
        const dropRefConst = drop.current;
        drop.current.addEventListener('dragover', handleDragOver);
        drop.current.addEventListener('drop', handleDrop);
        drop.current.addEventListener('dragenter', handleDragEnter);
        drop.current.addEventListener('dragleave', handleDragLeave);

        return () => {
            dropRefConst.removeEventListener('dragover', handleDragOver);
            dropRefConst.removeEventListener('drop', handleDrop);
            dropRefConst.removeEventListener('dragenter', handleDragEnter);
            dropRefConst.removeEventListener('dragleave', handleDragLeave);
        };
        // eslint-disable-next-line
    }, [drop]);


    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);

    };

    const showMessage = (message,time) => {
        setMsg(message);
        setTimeout(() => {
            setMsg(null);
        },time);
    }

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);

        const files = [...e.dataTransfer.files];

        uploadAndCheckFileMaster(files)

    };

    function uploadAndCheckFileMaster(files) {
        if (files.length > 1) {
            showMessage(`Nope, only 1 file can be uploaded at a time`, 2000);
            return;
        }

        if (files.some((file) =>  !file.name.toLowerCase().endsWith(".dcm"))) {
            showMessage(`Nope, only following file formats are acceptable: .dcm`, 2000);
            return;
        }

        if (files && files.length) {
            showMessage('Uploading...', 1000);
            props.onUpload(files[0]);
            console.log(files);
        }
    }
    const selectedFileFromBrowser = (e) => {
        uploadAndCheckFileMaster([...e.target.files]);
    }
    const chooseFile = () => fileInput.current.click()
    DragNDropFile.propTypes = {
        onUpload: PropTypes.func.isRequired,
    };


    let borderWidth = dragging ? 7 : 5;

    return (
            <div onClick={chooseFile} ref={drop} className="rounded d-flex flex-column align-items-center justify-items-center text-center" style={{borderStyle: "dashed",width: "100%", height: "100px", borderColor: "#7a7a7a", color: "#7a7a7a",borderWidth: borderWidth+"px"}}>
                {msg ? <b className="m-auto">{msg}</b> : <b className="m-auto">Drag & Drop files here<br/><small>Or click here</small></b>}
                <input type='file' onChange={selectedFileFromBrowser} ref={fileInput} hidden={true}/>
            </div>
    );
}